export default __webpack_public_path__ + "static/BUS_2-438347d3c28f6e2040fe5cf3c27ca789.jpg";